import { Capacitor } from "@capacitor/core";
import { SocialLogin } from "@capgo/capacitor-social-login";
import React, { useEffect, useRef, useState } from "react";

import AppleLoginButtonImage from "@assets/image/appleid_button@4x.png";

import { SocialLoginButton } from "./SocialLoginButton";

const AppleLoginButton = ({ onSuccess, onError, v2 = false, disabled = false }) => {
  const [pending, setPending] = useState(false);
  const busy = useRef(false);
  useEffect(() => {
    const initSocialLogin = async () => {
      if (Capacitor.isNativePlatform()) {
        if (Capacitor.getPlatform() === "ios") {
          await SocialLogin.initialize({
            apple: {},
          });
        } else {
          // Androidは非対応
        }
      } else {
        // Webは非対応
      }
    };
    initSocialLogin();
  }, []);

  const handleError = () => {
    onError?.();
  };

  const handleNativeLogin = async () => {
    if (busy.current || disabled) return;
    busy.current = true;
    setPending(true);
    try {
      const response = await SocialLogin.login({
        provider: "apple",
        options: {},
      });
      const result = response.result;
      // v8でJWTはidTokenに移動したが、サーバーは旧形式のaccessToken.tokenを読むため変換する
      await onSuccess({ ...result, accessToken: { token: result.idToken } });
    } catch (err) {
      handleError();
    } finally {
      busy.current = false;
      setPending(false);
    }
  };

  if (v2) return <SocialLoginButton provider="apple" disabled={disabled || pending} onClick={handleNativeLogin} />;

  return (
    <button
      type="button"
      disabled={disabled || pending}
      onClick={handleNativeLogin}
      style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
    >
      <img
        src={AppleLoginButtonImage}
        alt="Apple Login"
        style={{ width: "300", height: "40", display: "block", borderRadius: "4px" }}
      />
    </button>
  );
};

export default AppleLoginButton;
